import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgLoadInsp } from '../models/jg/jg-load-insp.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgLoadInspService extends RequestService<JgLoadInsp> {
  static PATH = '/jg/loadInsp';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, JgLoadInspService.PATH, globalService.debugUrl);
  }
}
